import React, { useState } from "react";

export default function Button({
  handleClick,
  value,
  title,
  handleAddClass,
  activeBtn,
}) {
  return (
    <button
      onClick={() => (handleClick(value), handleAddClass(value))}
      className={`${value === activeBtn ? "active" : ""}`}
    >
      {title}
    </button>
  );
}
